@if (initialized) {
  <ng-container>
    <div *ngIf="profile$ | async as profile" class="ats-fluig-root-height">
      <ng-container *ngIf="currentTheme$ | async as currentTheme">
        @if (profile) {
          <div class="po-wrapper">
            <header *ngIf="profileActions$ | async as actions">
              <po-toolbar [p-profile]="profile" [p-profile-actions]="actions" [p-title]="currentTheme.labels.appTitle | translate"></po-toolbar>
            </header>

            <po-menu
              #pomenu
              *ngIf="menu$ | async as menu"
              [p-menus]="menu"
              [p-collapsed]="menuStatus.collapsed"
              [p-automatic-toggle]="menuStatus.automaticToogle"
            >
              <ng-template p-menu-header-template>
                <a [routerLink]="['/']" class="btn-logo">
                  <img [src]="currentTheme.imageUrls.logoUrl" alt="" class="logo-home-link" />
                  <h1 class="visually-hidden">{{ currentTheme.labels.appTitle | translate }}</h1>
                </a>
              </ng-template>
            </po-menu>

            <main>
              <router-outlet />
            </main>

            <ats-lib-loader-global [menuInitialized]="menu$ | async | toBoolean" />
          </div>
        } @else {
          <ats-lib-spin-loader [absolute]="true" />
        }
      </ng-container>
      <ats-agree-terms />
    </div>
  </ng-container>
} @else {
  <ng-container>
    <ats-lib-spin-loader [absolute]="true" />
  </ng-container>
}
